module.exports = __webpack_public_path__ + "img/2-2.90ea4b5e.svg";